export default "__VITE_ASSET__46fd57ff__"